import { NetworkV2AppBaseDataProvider } from './NetworkV2AppBaseDataProvider';

export class NetworkV2AppNirvanaDataProvider extends NetworkV2AppBaseDataProvider {}
